import { Typography } from '@prenuvo/halo-web';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

interface ErrorPageProps {
  primaryTitle: string;
  secondaryTitle: string;
  message?: string;
  body?: React.ReactNode;
}

export const ErrorPage = ({ primaryTitle, secondaryTitle, message, body }: ErrorPageProps) => {
  const { setInsideCard } = usePrenuvoStore(
    useShallow((state) => ({
      setInsideCard: state.ui.methods.setInsideCard,
    })),
  );

  useEffect(() => {
    setInsideCard(false);
  }, []);

  return (
    <div className="mx-4 lg:h-[900px] lg:w-full lg:bg-[url('/images/female-body.png')] lg:bg-contain">
      <div className="lg:w-1/2 lg:pt-[200px]">
        <Typography variant="h2" as="h2" className="hidden text-teal-500 md:block">
          {primaryTitle}
        </Typography>
        <Typography variant="h3" as="h3" className="mt-10 text-teal-500 md:mt-2">
          {secondaryTitle}
        </Typography>
        {message && (
          <Typography variant="paragraph-lg" as="p" className="my-6">
            {message}
          </Typography>
        )}
        {body}
        <img className="md:hidden" src="/images/female-body-mobile.png" />
      </div>
    </div>
  );
};
